module.exports = __webpack_public_path__ + "static/media/icon_84.c6736ccc.svg";